<div class="status-page">
  <div class="status-card">
    <h2>Kontrol status</h2>

    <div class="form-group">
      <label for="lastServiceBy">Kontrol udført af</label>
      <input id="lastServiceBy"
             type="text"
             class="text-field"
             [ngModel]="equipment.lastServiceBy"
             disabled
             name="lastServiceBy" />
    </div>

    <div class="form-group">
      <label for="serviceFrequency">Kontrolfrekvens</label>
      <input id="serviceFrequency"
             type="text"
             class="text-field"
             [ngModel]="equipment.serviceFrequency"
             disabled
             name="serviceFrequency" />
    </div>

    <div class="form-group">
      <label for="lastServiceText">Sidste kontrol</label>
      <input id="lastServiceText"
             type="text"
             class="text-field"
             [ngModel]="equipment.lastServiceText"
             disabled
             name="lastServiceText" />
    </div>

    <div class="form-group">
      <label for="nextControlText">Næste kontrol</label>
      <input id="nextControlText"
             type="text"
             class="text-field"
             [ngModel]="equipment.nextControlText"
             disabled
             name="nextControlText" />
    </div>
  </div>
</div>
